import {Component,Inject, Input} from 'ng-metadata/core';

import serviceProviders, { AuthenticationService } from './authentication.service';
import {AuthenticationMethod, getAuthenticationMethods, getInstitutionCode} from '../../../appConfig/appConfigForward';
import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
import {LoginService} from '../../../security/login/login.service';
import {SharedSessionStorage} from '../../../infra/sharedSessionStorage.service';
import {UserSessionManagerService} from '../../../security/userSessionManager.service';
import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";

@Component({
"selector": 'prm-authentication',
templateUrl: 'components/search/topbar/userArea/authentication.html',
})


export class PrmAuthentication{
    @Input() private isLoggedIn : boolean;
    @Input() private idpLogout : boolean;
    private authenticationMethods =  getAuthenticationMethods();


    constructor(private authenticationService: AuthenticationService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                private primolyticsService: PrimolyticsService,
                private loginService: LoginService,
                @Inject('$location') private $location: ng.ILocationService,
                private sharedSessionStorage: SharedSessionStorage,
                private userSessionManagerService: UserSessionManagerService,
                private analyticsUtils: AnalyticsUtils) {
    }

    @beacon({'p':'general', 'op':'signIn'})
    handleLogin(authentication: AuthenticationMethod) {
        this.loginService.handleLoginClick();
        this.loginService.sendAnalytics('manually');
    }

    @beacon({'p':'general', 'op':'signOut'})
    handleLogout() {
        this.authenticationService.handleLogout();
        let payload = {
            'Sign Out  Method': 'manually' //Timeout
        }
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.SIGN_OUT, payload);
    }
    
    private isLoggedInIDP() {
       if (this.userSessionManagerService.isLoggedInIDP()){
            return true;
        }
        return this.isLoggedIn;
        
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/authentication.directive.ts